<template>
  <!-- <v-container fluid> -->
    <StaffTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $tc('categories.staff.name', 2) })"
        />
        <avs-createButton
          :to="{ name: 'StaffCreateUpdate' }"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.staff.name', 2).toLowerCase()
            })
          "
          :name="
            $t('actions.new_female', {
              entity: $tc('categories.staff.name', 2).toLowerCase()
            })
          "
        />
      </template>
    </StaffTable>
  <!-- </v-container> -->
</template>
<script>
import { StaffTable } from "@/components"
import { fmtCfsiData } from "@/utils/download"

export default {
  name: "StaffMemberView",
  components: { StaffTable },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset)
    }
  }
}
</script>
